import { readRuntimeEnv } from "./runtimeEnv";

export function getApiBaseUrl(): string | undefined {
  return readRuntimeEnv("VITE_API_BASE_URL");
}
